import { Box, Typography, Divider } from "@mui/joy";
import { PackageOpen } from "lucide-react";
import type { ProductWithPrice } from "../types";

interface ProductItemProps {
    product: ProductWithPrice;
}

export function ProductItem({ product }: ProductItemProps) {
    const hasPrice = product.UnitPrice && product.UnitPrice > 0;

    return (
        <Box>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={1.5}
                py={0.75}
            >
                <Box display="flex" alignItems="center" gap={1} minWidth={0} flex={1}>
                    <PackageOpen size={14} color="gray" style={{ flexShrink: 0 }} />
                    <Box minWidth={0}>
                        <Typography level="body-sm" sx={{ fontWeight: 500 }} noWrap>
                            {product.ProductName}
                        </Typography>
                        <Typography level="body-xs" sx={{ color: "text.secondary" }} noWrap>
                            {product.SupplierName || "No supplier"} · {product.ItemCount} Nos
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                    {hasPrice ? (
                        <>
                            <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                                ${product.UnitPrice.toFixed(2)} × {product.ItemCount}
                            </Typography>
                            <Typography level="body-sm" sx={{ fontWeight: 600 }}>
                                ${(product.Total || 0).toFixed(2)}
                            </Typography>
                        </>
                    ) : (
                        <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                            No price
                        </Typography>
                    )}
                </Box>
            </Box>
            <Divider />
        </Box>
    );
}
